// extracted by mini-css-extract-plugin
export default {"childrenContainer":"PrivateLayout_childrenContainer__FmgqC","sidebarClosed":"PrivateLayout_sidebarClosed__nL07u"};